__webpack_require__.p = "https://gamezone.cfl.ca/allcfl/";